import React from "react";
import LegalLayout from "@/pages/LegalLayout";

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-display text-xl md:text-2xl font-semibold text-white mb-4">
      {title}
    </h2>
    <div className="text-neutral-300 text-sm md:text-base leading-relaxed space-y-4">
      {children}
    </div>
  </section>
);

const KVKK = () => {
  return (
    <LegalLayout
      title="Kişisel Verilerin Korunması (KVKK)"
      subtitle="6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında aydınlatma metni."
    >
      <Section title="1. Veri Sorumlusu">
        <p>
          <span className="text-white">MoDuLerİS</span> ("Şirket"), 6698 sayılı Kişisel Verilerin
          Korunması Kanunu ("KVKK") uyarınca <em className="text-[#ff5a00] not-italic">veri sorumlusu</em>{" "}
          sıfatıyla, sizin tarafınızdan sağlanan kişisel verileri işbu aydınlatma metninde
          belirtilen amaç ve kapsamda işleyebilecektir.
        </p>
      </Section>

      <Section title="2. İşlenen Kişisel Veriler">
        <p>Web sitemiz üzerinden aşağıdaki kişisel veriler işlenmektedir:</p>
        <ul className="list-disc pl-6 space-y-2 text-neutral-300">
          <li>Kimlik bilgileri (ad, soyad, firma unvanı)</li>
          <li>İletişim bilgileri (e-posta, telefon)</li>
          <li>Proje detayları ve talep içeriği</li>
          <li>Web sitesi ziyaret bilgileri (IP adresi, tarayıcı bilgileri, çerezler)</li>
        </ul>
      </Section>

      <Section title="3. Kişisel Verilerin İşlenme Amacı">
        <p>Toplanan kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Talep ettiğiniz teklif ve danışmanlık hizmetlerinin sunulması</li>
          <li>Sizinle iletişim kurulması ve proje süreçlerinin yönetilmesi</li>
          <li>Yasal yükümlülüklerin yerine getirilmesi</li>
          <li>Hizmet kalitesinin iyileştirilmesi ve müşteri memnuniyetinin sağlanması</li>
        </ul>
      </Section>

      <Section title="4. Kişisel Verilerin Aktarılması">
        <p>
          Kişisel verileriniz, KVKK'nın 8. ve 9. maddelerine uygun olarak yalnızca yasal
          zorunluluklar çerçevesinde, hizmet aldığımız üçüncü taraf teknoloji sağlayıcılarına
          (barındırma, e-posta gönderim servisleri) ve yetkili kamu kurum ve kuruluşlarına
          aktarılabilir. Verileriniz yurt dışına aktarılmamaktadır.
        </p>
      </Section>

      <Section title="5. Kişisel Veri Sahibinin Hakları">
        <p>KVKK'nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
          <li>İşlenmişse buna ilişkin bilgi talep etme</li>
          <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme</li>
          <li>Yurt içinde/yurt dışında aktarıldığı üçüncü kişileri öğrenme</li>
          <li>Eksik veya yanlış işlenmişse düzeltilmesini isteme</li>
          <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde silinmesini/yok edilmesini isteme</li>
          <li>İşlenen verilerin münhasıran otomatik sistemler ile analiz edilmesi durumunda aleyhinize doğan sonuca itiraz etme</li>
          <li>Kanuna aykırı işleme sebebiyle zarara uğramanız halinde zararın giderilmesini talep etme</li>
        </ul>
      </Section>

      <Section title="6. İletişim">
        <p>
          KVKK kapsamındaki taleplerinizi{" "}
          <a href="mailto:moduleris@gmail.com" className="text-[#ff5a00] hover:underline">
            moduleris@gmail.com
          </a>{" "}
          e-posta adresi üzerinden veya Küner Mah. 2818 Sokak, Yeşil Ev, Menderes / İzmir
          adresine yazılı olarak iletebilirsiniz.
        </p>
      </Section>
    </LegalLayout>
  );
};

export default KVKK;
